var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "36px",
    viewBox: "0 0 40 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(70.588235%,82.745098%,20.392157%)",
      fillOpacity: 1
    },
    d: "M 27.902344 17.734375 L 27.621094 17.273438 L 18.203125 14.355469 L 17.9375 14.652344 L 17.53125 14.742188 L 9.160156 33.289062 L 9.269531 33.851562 L 29.433594 25.777344 L 29.605469 25.453125 L 28.199219 18.042969 Z M 27.902344 17.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(63.921569%,92.941176%,72.941176%)",
      fillOpacity: 1
    },
    d: "M 9.269531 33.851562 L 17.9375 14.652344 L 0.132812 9.140625 Z M 9.269531 33.851562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(50.980392%,85.490196%,91.372549%)",
      fillOpacity: 0.278431
    },
    d: "M 24.546875 0.046875 L 17.9375 14.652344 L 27.902344 17.734375 L 27.949219 17.617188 L 24.609375 0.179688 Z M 24.546875 0.046875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(72.54902%,81.960784%,32.54902%)",
      fillOpacity: 0.258824
    },
    d: "M 27.902344 17.734375 L 29.433594 25.777344 L 30.136719 25.761719 L 39.679688 21.835938 L 40.101562 21.496094 L 39.601562 21.097656 L 28.371094 17.511719 Z M 27.902344 17.734375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(50.980392%,85.490196%,91.372549%)",
      fillOpacity: 1
    },
    d: "M 29.433594 25.777344 L 31.386719 36.058594 L 40.101562 21.496094 Z M 24.546875 0.046875 L 27.902344 17.734375 L 40.101562 21.496094 Z M 24.546875 0.046875 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.27448511d828b05d8a6527c5b12a2e3d.svg";
export { ForwardRef as ReactComponent };